module.exports = __webpack_public_path__ + "img/green_098.c3c2e087.png";